module.exports = __webpack_public_path__ + "img/securecomLogo.23736a5b.png";